import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { faqs } from "./constant";
import "../../shared/styles/index.css";

const Faq = () => {
  const [isOpen, setIsOpen] = useState("-1");

  return (
 <div className="faq-container">
  <p className="faq-title">Frequently Asked Questions (FAQs)</p>

  {faqs.map((faq, index) => (
    <div key={faq.id} className="faq-item">
      <div
        className="row clickable"
        onClick={() =>
          setIsOpen(isOpen === String(index) ? "-1" : String(index))
        }
      >
        <div className="col-auto text-primary">{`Q${index+ 1}`}.</div>
        <div className="col">{faq.question}</div>
        <div className="col-auto icon">
          {isOpen === String(index) ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </div>
      </div>

      <div
        className="faq-answer"
        style={{
          maxHeight: isOpen === String(index) ? "200px" : "0",
          opacity: isOpen === String(index) ? 1 : 0,
          transform: isOpen === String(index)
            ? "translateY(0)"
            : "translateY(-10px)",
        }}
      >
        {isOpen === String(index) && <p>{faq.answer}</p>}
      </div>
    </div>
  ))}
</div>

  );
};

export default Faq;
